import React from "react";
import ReportExpByMDA from "./ReportExpByMDA";

const options = [
  { value: "total_ex_by_mda", title: "Total Expenditure by MDA", code: null },
  { value: "ex_by_mda_new", title: "Personnel Exp. by MDA", code: "Personnel" },
  { value: "ex_by_mda_new", title: "Other NDR Exp. by MDA", code: "OverHead" },
  { value: "ex_by_mda", title: "Debt Service by MDA", code: "2206%" },
  { value: "ex_by_mda_new", title: "Capital Exp. by MDA", code: "Capital" },
];

export default function ExpenditureByMDA() {
  return (
    <ReportExpByMDA
      defaultType="total_ex_by_mda"
      defaultTitle="Total Expenditure by MDA"
      options={options}
      route="reports"
      sheetName="Expenditure by MDA"
      chartType="get_head_eco"
    />
  );
}
